import {
  Dialog,
  DialogHeader,
  DialogBody,
  IconButton,
} from "@material-tailwind/react";

const SimpleModal = ({ open, onClose, children }) => {
  return (
    <Dialog open={open} handler={onClose} size="md">
      <DialogHeader>
        <IconButton
          variant="text"
          color="blue-gray"
          size="sm"
          onClick={onClose}
          className="!absolute top-2 right-2"
          aria-label="Close"
        >
          ×
        </IconButton>
      </DialogHeader>
      <DialogBody>{children}</DialogBody>
      {/* Optional: Add DialogFooter here if needed */}
    </Dialog>
  );
};

export default SimpleModal;
